<template>
  <OrdersSkeleton v-if="loading" />
  <div v-else class="card-content">
    <div class="card-content-item">
      <div class="card-content-result">
        <a :href="TEST_SO_N11 + '/selleroffice/order/orderManagement'">
          <span>Yeni Sipariş</span>
          <div class="card-count">{{ orderData.newOrderCount }}</div>

        </a>
      </div>

    </div>

    <div class="card-content-item">
      <div class="card-content-result">
        <a
        :href="TEST_SO_N11 + '/selleroffice/order/orderManagement?status=COMPLETED'"
        >
        <span>Tamamlandı</span>
        <strong>{{ orderData.shippedCount }}</strong>

        </a>
      </div>
    </div>

    <div class="card-content-item">
      <div class="card-content-result">
        <a
          :href="
            TEST_SO_N11 + '/selleroffice/order/orderManagement?status=ACCEPTED'
          "
        >
          <span>Kargoya Hazır</span>
          <strong>{{ orderData.readyToCargoCount }}</strong>
        </a>
      </div>
    </div>

    <div class="card-content-item">
        <div class="card-content-result">
        <a
        :href="
              TEST_SO_N11 +
              '/selleroffice/order/orderManagement?status=NOT_SHIPPED_ON_TIME'
            "
        >
        <span>Geciken Kargo</span>
        <strong>{{ orderData.lateShippedCount }}</strong>
          
        </a>
      </div>
      </div>

    <div class="card-content-item">
      <div class="card-content-result">
        <a
          :href="
            TEST_SO_N11 + '/selleroffice/order/orderManagement?status=SHIPPING'
          "
        >
          <span>Kargolandı</span>
          <strong class="order-value">{{ orderData.shippingCount }}</strong>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { Hr } from '@n11/so-ui-components';
import OrdersSkeleton from '@/components/OrdersCard/OrdersSkeleton';
import { ENVIRONMENT_HOSTS } from '@/utils/enum/enviromentHosts';

export default {
  name: 'OrdersCard',
  components: {
    Hr,
    OrdersSkeleton,
  },
  props: {
    orderData: {
      type: Object,
      required: false,
      // TODO: true
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      TEST_SO_N11: ENVIRONMENT_HOSTS.TEST_SO_N11,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mobiles.scss';
@import '@/assets/styles/mobilesFooter.scss';
@import '@/assets/styles/card.scss';

.hr {
  width: 90%;
  margin: 10px 0;
}

.card-content-result {
  strong {
    //margin-bottom: 6px;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 34px;
    letter-spacing: -0.4px;
    color: $colorN80;
  }
  span{
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    color: $colorM50;
  }
  .card-count{
    width: 179px;
    height: 34px;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 34px;
    color : $colorN80;
  }
}

.card-footer-item{
  gap: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.33;
   strong{
    margin-left: 0;
   }
  }
</style>
